import React, { FC } from 'react';
import { Title, Subtitle } from './styles';

interface Props {
  title: string;
  subtitle: string;
  className?: string;
  children?: React.ReactNode;
}

export const TableTitle = ({ title, subtitle, children, className }: Props) => {
  return (
    <Title aria-label={title} className={className}>
      {title}
      <Subtitle aria-label={subtitle}>{subtitle}</Subtitle>
      {children}
    </Title>
  );
};
